import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Input,
  Spin,
  Select,
  Divider,
  InputNumber,
  Space,
  Tag,
  DatePicker,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import BreadCrumb from "../../../layout/BreadCrumb";
import {
  fetchData,
  fetchLocation,
  fetchSubCounties,
  fetchSubLocation,
  fetchSubsidySource,
} from "../../../features/fetch/fetchSlice";
import { damStatusData } from "../../../data";
import dayjs from "dayjs";
import { normalizeDateToLocalYear } from "../../../utils";

const { TextArea } = Input;
const DamAdd = () => {
  const urlDamType = "dam_type/fetch_damtypes";
  const urlWtrSrce = "water_sources/fetch_watersourcess";
  const urlWtrAbstr = "water_abstraction_mode/fetch_waterabstractionmodes";
  const urlCrop = "main_crop/fetch_maincrops";
  const urlPathway = "api/v2/irrigationPathway/get";
  const urlAgency = "api/v2/agency/get";

  const urlWard = "ward/fetch_wards";
  const urlConstituency = "constituency/fetch_constituencys";

  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { counties, subCounties, locations, subLocations, subsidySources } =
    useSelector((state) => state.fetch);
  const {
    activeObjDam,
    dataDamType,
    dataWtrSrc,
    dataWtrAbstr,
    dataCrop,
    dataPathway,
    dataAgency,
    dataConstituency,
    dataWard,
  } = useSelector((state) => ({
    activeObjDam: state.obj.activeObj["dam"],
    dataDamType: state.fetch.data[urlDamType] || [],
    dataWtrSrc: state.fetch.data[urlWtrSrce] || [],
    dataWtrAbstr: state.fetch.data[urlWtrAbstr] || [],
    dataCrop: state.fetch.data[urlCrop] || [],
    dataPathway: state.fetch.data[urlPathway] || [],
    dataAgency: state.fetch.data[urlAgency] || [],

    dataWard: state.fetch.data[urlWard] || [],
    dataConstituency: state.fetch.data[urlConstituency] || [],
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleCancel() {
    navigate("/rob/dams-list");
  }

  const [countyName, setCountyName] = useState(activeObjDam?.countyName ?? "");

  const onFinish = async (data) => {
    data.damId = activeObjDam?.damId ? activeObjDam?.damId : null;
    data.damCropsId = Array.isArray(data?.damCropsId)
      ? data?.damCropsId.join(",")
      : data?.damCropsId;
    data.damPathwayId = Array.isArray(data?.damPathwayId)
      ? data?.damPathwayId.join(",")
      : data?.damPathwayId;

    data.damSourceFundsId = Array.isArray(data?.damSourceFundsId)
      ? data?.damSourceFundsId.join(",")
      : data?.damSourceFundsId;
    data.damStartDate = normalizeDateToLocalYear(data?.damStartDate);
    data.damEndDate = normalizeDateToLocalYear(data?.damEndDate);
    const res = await dispatch(
      save({
        ...data,
        url: "dam/save_dam",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

   
  const [countyId, setCountyId] = useState(activeObjDam?.damCountyId ?? "");
  const [constituencyId, setConstituencyId] = useState(
    activeObjDam?.damConstId ?? ""
  );
  const [subCountyId, setSubCountyId] = useState(
    activeObjDam?.damSubCountyId ?? ""
  );
  const [locationId, setLocationId] = useState(
    activeObjDam?.damLocationId ?? ""
  );
  const [subLocationId, setSubLocationId] = useState(
    activeObjDam?.damSubLocationId ?? ""
  );
  const [wardId, setWardId] = useState(activeObjDam?.damWardId ?? "");

  const handleCountyChange = async (value) => {
    setCountyId(value);
    setConstituencyId("");
    setSubCountyId("");
    setLocationId("");
    setSubLocationId("");
    setWardId("");

    form.setFieldsValue({
      damCountyId: value,
      damConstId: "",
      damSubCountyId: "",
      damLocationId: "",
      damSubLocationId: "",
      damWardId: "",
    });
    await dispatch(fetchSubCounties({ subCountyId: value }));
    await dispatch(
      fetchData({
        url: urlConstituency,
        constCountyId: value,
      })
    );
  };

  const handleConstituencyChange = async (value) => {
    setConstituencyId(value);
    setWardId("");
    form.setFieldsValue({ damConstId: value, damWardId: "" });
    await dispatch(
      fetchData({
        url: urlWard,
        wdConstId: value,
      })
    );
  };

  const handleSubCountyChange = async (value) => {
    setSubCountyId(value);
    setLocationId("");
    setSubLocationId("");
    form.setFieldsValue({
      damSubCountyId: value,
      damLocationId: "",
      damSubLocationId: "",
    });
    await dispatch(fetchLocation({ locSubId: value }));
  };

  const handleLocationChange = async (value) => {
    setLocationId(value);
    setSubLocationId("");
    form.setFieldsValue({ damLocationId: value, damSubLocationId: "" });
    await dispatch(fetchSubLocation({ slocLocId: value }));
  };

  const handleSubLocationChange = (value) => {
    setSubLocationId(value);
    form.setFieldsValue({ damSubLocationId: value });
  };

  const handleWardChange = (value) => {
    setWardId(value);
    form.setFieldsValue({ damWardId: value });
  };

  const updateCategory = (size) => {
    if (size >= 0 && size <= 4.99) return "Class A";
    if (size >= 5 && size <= 14.99) return "Class B";
    if (size > 15) return "Class C";
    return "";
  };

  const handleDatesChange = (changedValues, allValues) => {
    const { damStartDate, damEndDate, damHeight } = allValues;

    if (damStartDate && damEndDate) {
      const diff = dayjs(damEndDate).diff(dayjs(damStartDate), "day");
      form.setFieldsValue({
        damTimeFrame: `${diff} day${diff !== 1 ? "s" : ""}`,
      });
    } else {
      form.setFieldsValue({ damTimeFrame: "" });
    }

    if (changedValues?.damHeight !== undefined) {
      if (damHeight === undefined || damHeight === null || damHeight === "") {
        form.setFieldsValue({ damClassification: "" });
      } else {
        const categoryValue = updateCategory(damHeight);
        form.setFieldsValue({ damClassification: categoryValue });
      }
    }
  };

  useEffect(() => {
    dispatch(
      fetchData({
        url: urlDamType,
        limit: null,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlWtrSrce,
        limit: null,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlWtrAbstr,
        limit: null,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlCrop,
        limit: null,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlPathway,
        limit: null,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlAgency,
        limit: null,
        start: 0,
      })
    );

    dispatch(fetchSubsidySource());
  }, []);

  const initialFormValues = {
    ...activeObjDam,
    damStartDate: activeObjDam?.damStartDate
      ? dayjs(new Date(activeObjDam?.damStartDate))
      : null,
    damEndDate: activeObjDam?.damEndDate
      ? dayjs(new Date(activeObjDam?.damEndDate))
      : null,
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeObjDam,
      damStartDate: activeObjDam?.damStartDate
        ? dayjs(new Date(activeObjDam?.damStartDate))
        : null,
      damEndDate: activeObjDam?.damEndDate
        ? dayjs(new Date(activeObjDam?.damEndDate))
        : null,
    });
    if (activeObjDam?.damSourceFundsId) {
      form.setFieldsValue({
        damSourceFundsId: activeObjDam?.damSourceFundsId
          ?.split(",")
          ?.map((b) => b?.trim()),
      });
    }
    if (activeObjDam?.damCropsId) {
      form.setFieldsValue({
        damCropsId: activeObjDam?.damCropsId?.split(",")?.map((b) => b?.trim()),
      });
    }
    if (activeObjDam?.damPathwayId) {
      form.setFieldsValue({
        damPathwayId: activeObjDam?.damPathwayId
          ?.split(",")
          ?.map((b) => b?.trim()),
      });
    }
  }, [activeObjDam, form]);

  useEffect(() => {
    if (activeObjDam?.damId) {
      dispatch(
        fetchSubCounties({
          subCountyId: activeObjDam?.damCountyId,
        })
      );
      dispatch(
        fetchData({
          url: urlConstituency,
          constCountyId: activeObjDam?.damCountyId,
        })
      );

      dispatch(
        fetchData({
          url: urlWard,
          wdConstId: activeObjDam?.damConstId,
        })
      );
      dispatch(
        fetchLocation({
          locSubId: activeObjDam?.damSubCountyId,
        })
      );
      dispatch(
        fetchSubLocation({
          slocLocId: activeObjDam?.damLocationId,
        })
      );
    }
  }, [activeObjDam, form]);

  return (
    <div className="w-full ">
      <BreadCrumb
        breadcrumbs={[
          { title: "Dam", path: "/rob/dams-list" },
          { title: "Dam Form" },
        ]}
      />
      <div className="white_card mt-[2.06rem]">
        <div className="form-add-h mb-[1.25rem]">Dam Information</div>
        <Divider />
        <div className="w-full mt-[1.75rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
            initialValues={initialFormValues}
            onValuesChange={handleDatesChange}
          >
            <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="damName"
                label={"Name of Dam"}
                rules={[
                  {
                    required: true,
                    message: "Please add name of dam",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>

              <Form.Item
                name="damCountyId"
                label="County"
                rules={[{ required: true, message: "Please select county" }]}
              >
                <Select
                  allowClear
                  options={counties?.map((c) => ({
                    value: c?.countyId,
                    label: c?.countyName,
                  }))}
                  onChange={handleCountyChange}
                  showSearch
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase()?.includes(input.toLowerCase())
                  }
                />
              </Form.Item>

              {countyId && (
                <>
                  <Form.Item
                    name="damConstId"
                    label="Constituency"
                    rules={[
                      { required: true, message: "Please select constituency" },
                    ]}
                  >
                    <Select
                      allowClear
                      options={dataConstituency?.map((c) => ({
                        value: c?.constId,
                        label: c?.constName,
                      }))}
                      onChange={handleConstituencyChange}
                      showSearch
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          ?.includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>

                  <Form.Item
                    name="damSubCountyId"
                    label="Subcounty"
                    rules={[
                      { required: true, message: "Please select subcounty" },
                    ]}
                  >
                    <Select
                      allowClear
                      options={subCounties?.map((s) => ({
                        value: s?.subId,
                        label: s?.subCountyName,
                      }))}
                      onChange={handleSubCountyChange}
                      showSearch
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          ?.includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </>
              )}

              {subCountyId && (
                <Form.Item
                  name="damLocationId"
                  label="Location"
                  rules={[
                    { required: true, message: "Please select location" },
                  ]}
                >
                  <Select
                    allowClear
                    options={locations?.map((l) => ({
                      value: l?.locId,
                      label: l?.locLocation,
                    }))}
                    onChange={handleLocationChange}
                    showSearch
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              )}

              {locationId && (
                <Form.Item
                  name="damSubLocationId"
                  label="Sublocation"
                  rules={[
                    { required: true, message: "Please select sublocation" },
                  ]}
                >
                  <Select
                    allowClear
                    options={subLocations?.map((sl) => ({
                      value: sl?.slocId,
                      label: sl?.slocLocation,
                    }))}
                    onChange={handleSubLocationChange}
                    showSearch
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              )}

              {constituencyId && (
                <Form.Item
                  name="damWardId"
                  label="Ward"
                  rules={[{ required: true, message: "Please select ward" }]}
                >
                  <Select
                    allowClear
                    options={dataWard?.map((w) => ({
                      value: w?.wdId,
                      label: w?.wdWard,
                    }))}
                    onChange={handleWardChange}
                    showSearch
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              )}

              <Form.Item
                name="damLat"
                label={"GPS Latitude (Decimal degrees, WGS84)"}
                rules={[
                  {
                    required: true,
                    message: "Please add latitude",
                  },
                ]}
              >
                <InputNumber
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="damLong"
                label={"GPS Longitude (Decimal degrees, WGS84)"}
                rules={[
                  {
                    required: true,
                    message: "Please add longitude",
                  },
                ]}
              >
                <InputNumber
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="Ksh. e.g 500"
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="damCost"
                label={"Cost"}
                rules={[
                  {
                    required: true,
                    message: "Please add cost",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="Enter value"
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="damWaterSourceId"
                className=""
                label={"Water Source"}
                rules={[
                  {
                    required: true,
                    message: "Please select water source",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataWtrSrc?.length > 0 &&
                    dataWtrSrc?.map((item) => ({
                      value: item?.wtrId,
                      label: item?.wtrSource,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name="damTypeId"
                className=""
                label={"Dam Type"}
                rules={[
                  {
                    required: true,
                    message: "Please select Dam Type",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataDamType?.length > 0 &&
                    dataDamType?.map((item) => ({
                      value: item?.dmId,
                      label: item?.dmType,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name="damVolume"
                label={"Volume of Water (M³)"}
                rules={[
                  {
                    required: true,
                    message: "Please add volume of water (M³)",
                  },
                ]}
              >
                <InputNumber
                  suffix={
                    <span>
                      M<sup>3</sup>
                    </span>
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="damWaterAbstractionModeId"
                className=""
                label={"Mode of Water Abstraction"}
                rules={[
                  {
                    required: true,
                    message: "Please select mode of water abstraction",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataWtrAbstr?.length > 0 &&
                    dataWtrAbstr?.map((item) => ({
                      value: item?.waId,
                      label: item?.waType,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>

              <Form.Item
                name="damEstBeneficiaries"
                label={"Estimated Households"}
                rules={[
                  {
                    required: true,
                    message: "Please add households",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="Enter value"
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="damAcreage"
                label={"Acreage"}
                rules={[
                  {
                    required: true,
                    message: "Please add Acreage",
                  },
                ]}
              >
                <InputNumber
                  suffix="Acres"
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="Ksh. e.g 500"
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                label={"Major Crops"}
                name="damCropsId"
                rules={[
                  {
                    required: true,
                    message: "Required field",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  dropdownRender={(menu) => (
                    <>
                      <Space style={{ padding: "8px 8px 4px" }}>
                        <span className="select-info mt-1">
                          Choose one or more of the following crops
                        </span>
                      </Space>
                      <Divider style={{ margin: "8px 0" }} />
                      {menu}
                    </>
                  )}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.children?.toLowerCase() ?? "").includes(
                      input.toLowerCase()
                    )
                  }
                  dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
                >
                  {dataCrop?.length > 0 &&
                    dataCrop?.map((item) => (
                      <Select.Option key={item?.cropId} value={item?.cropId}>
                        {item?.cropName}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="damStatus"
                className=""
                label={"Status"}
                rules={[
                  {
                    required: true,
                    message: "Please select status",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    damStatusData?.length > 0 &&
                    damStatusData?.map((item) => ({
                      value: item?.value,
                      label: item?.label,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                label="Start Date"
                name="damStartDate"
                rules={[
                  {
                    required: true,
                    message: "Start date is required",
                  },
                ]}
              >
                <DatePicker format={"YYYY MMM DD"} className="input" />
              </Form.Item>
              <Form.Item
                label="End Date"
                name="damEndDate"
                rules={[
                  {
                    required: true,
                    message: "End date is required",
                  },
                ]}
              >
                <DatePicker format={"YYYY MMM DD"} className="input" />
              </Form.Item>
              <Form.Item
                label="Time Frame"
                name="damTimeFrame"
                rules={[
                  {
                    required: true,
                    message: "Time Frame date is required",
                  },
                ]}
              >
                <Input disabled className="input" />
              </Form.Item>
              <Form.Item
                label="Source of Funding"
                name="damSourceFundsId"
                rules={[
                  { required: true, message: "Source of Funding is required" },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  dropdownRender={(menu) => (
                    <>
                      <Space style={{ padding: "8px 8px 4px" }}>
                        <span className="select-info mt-1">
                          Choose one or more of the following sources
                        </span>
                      </Space>
                      <Divider style={{ margin: "8px 0" }} />
                      {menu}
                    </>
                  )}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.children?.toLowerCase() ?? "").includes(
                      input.toLowerCase()
                    )
                  }
                  tagRender={(props) => {
                    const { label, closable, onClose } = props;
                    return (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          padding: "4px 8px",
                          margin: "2px",
                          borderRadius: "4px",
                          background: "#f5f5f5",
                        }}
                      >
                        {label}
                        {closable && (
                          <span
                            onClick={onClose}
                            style={{
                              marginLeft: "8px",
                              cursor: "pointer",
                              color: "red",
                            }}
                          >
                            ×
                          </span>
                        )}
                      </span>
                    );
                  }}
                  dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
                >
                  {subsidySources?.map((item) => (
                    <Select.Option
                      key={item?.subsidySourceId}
                      value={item?.subsidySourceId}
                    >
                      {item?.subsidySourceName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label={"Pathways"}
                name="damPathwayId"
                rules={[
                  {
                    required: true,
                    message: "Please add pathways",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  dropdownRender={(menu) => (
                    <>
                      <Space style={{ padding: "8px 8px 4px" }}>
                        <span className="select-info mt-1">
                          Choose one or more of the following pathways
                        </span>
                      </Space>
                      <Divider style={{ margin: "8px 0" }} />
                      {menu}
                    </>
                  )}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.children?.toLowerCase() ?? "").includes(
                      input.toLowerCase()
                    )
                  }
                  dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
                >
                  {dataPathway?.length > 0 &&
                    dataPathway?.map((item) => (
                      <Select.Option
                        key={item?.irrigationPathwayId}
                        value={item?.irrigationPathwayId}
                      >
                        {item?.irrigationPathwayName}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="damLivestockNo"
                label={"Livestock"}
                rules={[
                  {
                    required: true,
                    message: "Please add livestock",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="Enter value"
                  className="input flex"
                />
              </Form.Item>

              <Form.Item
                name="damAgencyId"
                className=""
                label={"Implementing Entity/Department"}
                rules={[
                  {
                    required: true,
                    message: "Please select Implementing Entity/Department",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataAgency?.length > 0 &&
                    dataAgency?.map((item) => ({
                      value: item?.agencyId,
                      label: item?.agencyName,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>

              <Form.Item
                name="damManagingAgency"
                label={"Managing Entity"}
                rules={[
                  {
                    required: true,
                    message: "Please add Managing Entity",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>

              <Form.Item
                name="damHeight"
                label={"Height (M)"}
                rules={[
                  {
                    required: true,
                    message: "Please add height (m)",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="Enter value"
                  className="input flex"
                />
              </Form.Item>

              <Form.Item
                name="damClassification"
                label={"Classification"}
                rules={[
                  {
                    required: true,
                    message: "Please add Classification",
                  },
                ]}
              >
                <Input disabled className="input" />
              </Form.Item>
            </div>
            <Form.Item
              name="damDesc"
              label={"Remarks"}
              rules={[
                {
                  required: true,
                  message: "Please add remarks",
                },
              ]}
            >
              <TextArea
                placeholder="Description..."
                rows={5}
                className="text_area"
              />
            </Form.Item>
            <div className="flex justify-between mt-[48px] ">
              <div className="justify-start"></div>
              <div className="justify-end flex items-center mb-[58px] gap-x-5">
                <div className="w-[150px]">
                  <button
                    type="button"
                    key="back"
                    onClick={handleCancel}
                    className="cstm-btn"
                  >
                    Cancel
                  </button>
                </div>

                <div className="w-[150px]">
                  <button key="submit" type="submit" className="cstm-btn-2">
                    {saving ? (
                      <Spin />
                    ) : activeObjDam?.damId ? (
                      "Update"
                    ) : (
                      "Create"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default DamAdd;
